import styles from './FAQPage.module.css';

import icon from '../../assets/FAQ-icon.svg';
import SupIcon from '../../assets/support-icon.svg';

import { Header } from '../../components/Header/Header';
import { TextDropbox } from '../../UI/TextDropbox/TextDropbox';
import { FooterBtn } from '../../UI/FooterBtn/FooterBtn';

export const FAQPage = () => {
	return (
		<div className='main'>
			<Header />
			<div className={'title_block'}>
				<img src={icon} alt="icon" />
				<h2>FAQ</h2>
			</div>
			<div className={styles.mainBlock}>
				<TextDropbox title={'Какие страны можно пополнить?'}>
					Пополнение возможно для аккаунтов России, Казахстана, Беларуси. На KZ аккаунт деньги будут зачислены в Тенге - курс плавающий.
					Пополнение аккаунтов в регионах Крым, ЛНР и ДНР невозможно.
				</TextDropbox>
				<TextDropbox title={'Какие способы оплаты есть?'}>
					Самые популярные способы оплаты у нашего сервиса: СБП и картой.
				</TextDropbox>
				<TextDropbox title={'Лимиты и ограничения'}>
					Ограничения на минимальные суммы для всех способов зачисления – 100 рублей, 500 тенге, 116.50 долларов. Лимит на максимальное пополнение баланса Steam на один логин за 24 часа – равен 30 000 рублей.<br /><br />

					ВНИМАНИЕ: ограничение распространяется на все способы пополнения. Если вы где-то уже пополнили ваш Steam на сумму 500$, наше пополнение может не пройти в связи с лимитом, будьте внимательны!
				</TextDropbox>
				<TextDropbox title={'Что такое “Логин”?'}>
					Это то, что вы вводите при авторизации, у каждого пользователя он уникальный, а никнейм вы можете менять по своему усмотрению.
				</TextDropbox>
				<TextDropbox title={'У меня новый или ранее НЕ пополнявшийся аккаунт'}>
					Если совершаете первое пополнение аккаунта Steam, то валюта аккаунта может смениться на одну из списка ($, ₸, € и другие). Страна аккаунта тоже будет изменена автоматически.<br /><br />

					В этом случае цены на внутренние товары будут пересчитываться в валюту аккаунта ($, ₸, € и другие), а не ₽ (рубли). Учтите это при пополнении!<br /><br />

					Чтобы этого избежать нужно добавить в библиотеку бесплатную игру обязательно с телефона. Тогда за Вами закрепится нужный регион.
				</TextDropbox>
				<TextDropbox title={'Пришла сумма меньше'}>
					Для пополнения нам приходится конвертировать средства в разные валюты.<br /><br />

					Иногда сумма может отличаться на 1-5% от указанной.
				</TextDropbox>
				<TextDropbox title={'Не пришли деньги на кошелек Steam'}>
					Если Вы указали верно ЛОГИН (это не никнейм) и баланс Вашего аккаунта - рубли (₽), тенге (₸) или доллары ($), пополнение происходит моментально.<br /><br />

					Если Вам не поступили средства на баланс в течение часа, пожалуйста, обратитесь в Техническую поддержку.
				</TextDropbox>
				<TextDropbox title={'Возврат средств'}>
					Если вы проигнорировали требования к аккаунту и все же попытались отправить себе средства, то они не дойдут. В случае если регион аккаунта Steam не Россия (Рубли), Беларусь (Белорусские рубли), Казахстан (Тенге) возврат невозможен по причине невозможности возврата денежных средств платёжной системой.
				</TextDropbox>
				<TextDropbox title={'Какой картой я могу оплатить?'}>
					С помощью EazyPass можно пополнить баланс Стим банковской картой любого банка — в том числе Сбера, Т-банка, ВТБ, Альфа, и большинства небанковских финансовых организаций (ЮMoney и прочие). Комиссия за транзакцию не взимается с нашей стороны, а средства зачисляются моментально. Учтите, что некоторые банки могут применять собственные ограничения на онлайн-платежи, поэтому рекомендуем заранее убедиться, что ваша карта активирована для интернет-покупок.
				</TextDropbox>
			</div>
			<footer className={styles.footer}>
				<FooterBtn
					img={SupIcon}
					title={'Support'}
					description={'На всякий, если у вас будут вопросы'}
					width={'100%'}
					url={'https://t.me/eazysupp'}
				/>
			</footer>
		</div>
	);
};
